// 简体中文语言包 (Chinese Simplified Dictionary for Dental Lab)
const zh = {
    common: {
        loading: '加载中...',
        save: '保存',
        cancel: '取消',
        delete: '删除',
        edit: '修改',
        back: '返回',
        close: '关闭',
        search: '搜索',
        filter: '筛选',
        actions: '操作',
        confirm: '确认',
        download: '下载',
        details: '详情',
        none: '无',
        all: '全部',
        today: '今天',
        this_week: '本周',
        this_month: '本月',
        urgent: '加急',
        late: '已逾期',
        status: '状态',
        date: '日期',
        translate: '翻译成中文',
        translating: '翻译中...',
        show_original: '显示原文',
        translated: '已翻译',
        error: '错误',
        success: '成功'
    },
    nav: {
        dashboard: '仪表盘',
        jobs: '生产工单',
        clients: '门诊医生',
        accounting: '财务账单',
        products: '产品库',
        profile: '个人中心',
        settings: '系统设置',
        logout: '退出登录',
        lab_manager: '技工所主管',
        partner: '生产合作伙伴 (工厂)',
        switch_language: '语言切换'
    },
    status: {
        all: '全部状态',
        recu: '已接收',
        en_cours: '制作中',
        production: '生产中',
        en_attente: '等待处理/确认',
        termine: '制作完成',
        expedie: '已发货',
        livre: '已送达',
        facture: '已开票',
        annule: '已取消',
        a_refaire: '返工重做',
        pending_reply: '等待回复'
    },
    labwork: {
        search_placeholder: '搜索患者姓名、医生、工单编号...',
        all_dates: '全部时间',
        filter_status_label: '生产状态：',
        filter_date_label: '时间范围：',
        col_number: '工单号',
        col_date_received: '接收日期',
        col_patient: '患者姓名',
        col_practitioner: '门诊医生',
        col_work: '制作项目',
        col_teeth: '牙位',
        col_shade: '比色/色号',
        col_status: '当前状态',
        col_delivery: '预计出货/交货',
        col_actions: '操作',
        no_cases_found: '未找到符合条件的工单',
        unread_msg: '条未读消息',
        waiting_reply_badge: '等待回复',
        days_left: '天剩余',
        today_deadline: '今天必须出货！',
        overdue: '已超期',
        open_dossier: '查看工单详情',
        chat: '即时沟通',
        has_3d: '含 3D 模型/扫描件'
    },
    dossier: {
        back_to_list: '返回工单列表',
        title: '义齿生产制作工单',
        case_no: '工单编号',
        subcontractor_view: '工厂生产视图',
        practitioner_box: '门诊与医生信息',
        patient_box: '患者信息',
        received_date: '接收日期：',
        due_date: '要求出货日期：',
        status_label: '当前工单状态：',
        table_tooth: '牙位',
        table_work: '制作项目及类型',
        table_qty: '数量',
        table_shade: '比色/色号',
        work_instruction: '制作要求：',
        work_notes_title: '特殊制作要求与技工备注',
        mandatory_instruction: '重要！必须严格遵守的制作要求',
        no_special_notes: '该工单无特殊制作备注。',
        general_notes: '工单通用备注：',
        attached_files_title: '设计文档与 3D 扫描模型 (STL)',
        view_3d_files: '查看 3D 模型',
        open_chat: '打开即时沟通',
        chat_subtitle: '与法国技工所实时沟通',
        change_status_prompt: '更新生产状态：',
        save_status: '确认更新状态',
        translate_all_notes: '一键翻译所有制作要求'
    },
    chat: {
        title: '工单即时沟通与答疑',
        empty_title: '暂无沟通记录',
        empty_producer: '如有制作疑问或设计问题，请在此直接向技工所留言',
        empty_lab: '开始与工厂团队沟通',
        sender_lab: '🏭 法国技工所 ENOVADENT',
        sender_partner: '👤 生产工厂 (您)',
        placeholder: '输入消息内容...',
        send: '发送',
        translate_msg: '翻译成中文',
        translate_to_fr: '翻译成法语',
        translated_by_ai: '智能自动翻译',
        view_original: '显示原文',
        delete_confirm: '确定删除此消息吗？',
        just_now: '刚刚',
        typing: '正在输入...'
    }
};

export default zh;
